import { render, staticRenderFns } from "./Payments.vue?vue&type=template&id=bade9b1c&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=ts"
export * from "./Payments.vue?vue&type=script&lang=ts"
import style0 from "./Payments.vue?vue&type=style&index=0&id=bade9b1c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bade9b1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bade9b1c')) {
      api.createRecord('bade9b1c', component.options)
    } else {
      api.reload('bade9b1c', component.options)
    }
    module.hot.accept("./Payments.vue?vue&type=template&id=bade9b1c&scoped=true", function () {
      api.rerender('bade9b1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/Payments.vue"
export default component.exports